var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8928 2.53439L14.7988 0.434389C14.7284 0.363858 14.6329 0.324219 14.5333 0.324219C14.4336 0.324219 14.3381 0.363858 14.2678 0.434389L5.42376 9.28439C5.35341 9.35492 5.25788 9.39456 5.15826 9.39456C5.05864 9.39456 4.96311 9.35492 4.89276 9.28439L2.79876 7.18439C2.72841 7.11386 2.63288 7.07422 2.53326 7.07422C2.43364 7.07422 2.33811 7.11386 2.26776 7.18439L0.17376 9.28439C0.0273665 9.43083 0.0273665 9.6682 0.17376 9.81464L4.89276 14.5344C4.96311 14.6049 5.05864 14.6446 5.15826 14.6446C5.25788 14.6446 5.35341 14.6049 5.42376 14.5344L16.8928 3.05939C17.0357 2.91357 17.0357 2.68021 16.8928 2.53439Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/CorrectIcon.39c961fc0694093b031f6d489a00ceb8.svg";
export { ForwardRef as ReactComponent };